import 'choerodon-ui/lib/notification/style';
